export enum SwMessages {
  AppVersionRequest = 'APP_VERSION_REQUEST',
  AppVersionResponse = 'APP_VERSION_RESPONSE',
  AppReloadRequest = 'APP_RELOAD_REQUEST',
  AppReloadSuggestion = 'APP_RELOAD_SUGGESTION',
  SwActivated = 'SW_ACTIVATED' // when a new version of SW is activated
}
